import React, { useState, useEffect } from 'react'
import mintImage from '../../images/MintImage2.png'
import scaryTrees from '../../images/scaryTrees.jpg'
import MetaMaskOnboarding from '@metamask/onboarding'
import { FaMinus, FaPlus } from 'react-icons/fa'
import {
  mintToken,
  getSupply,
  supplyEvent,
  isMetaMaskInstalled,
  currentConnectedAddress,
  requestAccounts,
  getWhitelistedMints, getMintingState
} from '../../Contract/Web3Client'
import { 
  InfoContainer,
  InfoWrapper,
  InfoRow, 
  TextWrapper, 
  TopLine, 
  Heading, 
  BtnWrap,
  ImgWrap,
  Img,
  MintSectionBg,
  Btn,
  MintUiWrapper,
  AmountButton,
  TextFieldLabel
   } from './MintElements.js'
  

const MintSection = () => {
  const { ethereum, forwarderOrigin } = window
  const onboarding = new MetaMaskOnboarding({ forwarderOrigin })
  const [disableMintButton, setDisableMintButton] = useState(false)
  const [walletAddress, setWalletAddress] = useState('')
  const [btnText, setBtnText] = useState('Connect MetaMask')
  const [displayMintUi, setDisplayMintUi] = useState(false)
  const [mintAmount, setMintAmount] = useState(1)
  const [supply, setSupply] = useState(0)

  // walletstate
  // "uninstalled"
  // "unconnected"
  // "connected"
  const [metamaskState, setMetamaskState] = useState("uninstalled");
  const [mintingState, setMintingState] = useState(0);
  const [whitelistMints, setWhitelistMints] = useState(0);

  const mintAmountMap = {
    1: '0.06',
    2: "0.12",
    3: "0.18",
    4: "0.24",
    5: '0.30',
    6: '0.36',
    7: '0.42',
    8: '0.48',
    9: '0.54',
    10: '0.60'
  }

  useEffect(async () => {
    try {
      await getCurrentConnectedWallet()
      addWalletListener()
      setMintingState(await getMintingState())
    }
    catch (e) {
      console.error("initial: " + JSON.stringify(e));
    }
  }, [])

  useEffect(async () => {
    await getTotalSupply()
    setWhitelistMints(await getWhitelistedMints(walletAddress))
  }, [walletAddress])

  const validateMintAmount = () => {
    if (!displayMintUi) {
      return;
    }

    if (mintingState === 2) {
      setMintAmount(Math.min(6666 - supply, 10, mintAmount));
    }
    else if (mintingState === 1) {
      setMintAmount(Math.min(Math.max(whitelistMints - 1000, 0), mintAmount));
    }
  }

  const cantIncreaseMintAmount = () => {
    if (mintingState === 2) {
      return mintAmount >= Math.min(6666 - supply, 10);
    }
    else if (mintingState === 1) {
      return mintAmount >= (whitelistMints - 1000);
    }
    else {
      return true;
    }
  }


  const cantDecreaseMintAmount = () => {
    return mintAmount <= 1;
  }

  useEffect(validateMintAmount, [mintAmount]);

  useEffect(async () => {
    if (metamaskState === "uninstalled") {
      setBtnText("Click to install MetaMask");
      return;
    }
    else if (metamaskState === "unconnected") {
      setBtnText("Connect MetaMask");
      return;
    }

    switch (mintingState) {
      case 0:
        setDisplayMintUi(false);
        setDisableMintButton(true)
        setBtnText("Mint wen?")
        break;
      case 1:
        if (whitelistMints < 1000) {
          setDisplayMintUi(false);
          setDisableMintButton(true)
          setBtnText("Not whitelisted")
        }
        else {
          if (whitelistMints === 1000) {
            setDisplayMintUi(false);
            setDisableMintButton(true)
            setBtnText("Out of WL mints")
          } else {
            setDisplayMintUi(true);
            setDisableMintButton(false)
            validateMintAmount();
            setBtnText(`Mint (${whitelistMints - 1000} left)`)
          }
        }
        break;
      case 2:
        if (supply === 6666) {
          setDisplayMintUi(false);
          setDisableMintButton(true)
          setBtnText("Sold out")
        }
        else {
          setDisplayMintUi(true);
          setDisableMintButton(false)
          validateMintAmount();
          setBtnText("Mint Bit Monster")
        }
    }
  }, [metamaskState, supply, mintingState, whitelistMints])

  const getTotalSupply = () => {
    return getSupply(walletAddress).then(supply => {
      setSupply(supply)
    }).catch(err => {
      console.log("getTotalSupply: " + err)
    })
  }

  const getCurrentConnectedWallet = async () => {
    if(isMetaMaskInstalled()){
      try {
        const addressArray = await currentConnectedAddress()
        if(addressArray.length > 0) {
          setWalletAddress(addressArray[0])
          supplyEvent(getTotalSupply)
          setMetamaskState("connected")
        } else {
          setMetamaskState("unconnected")
        }
      } catch (error) {
        setMetamaskState("unconnected")
        console.log(error)
      }
    } else {
      setMetamaskState("uninstalled")
    }
  }

  const addWalletListener = () => {
    if(isMetaMaskInstalled()){
      ethereum.on('accountsChanged', (accounts) => {
        if(accounts.length > 0) {
          setWalletAddress(accounts[0])
        } else {
          setWalletAddress('')
          setDisplayMintUi(false)
        }
      })
    } else {
      setDisplayMintUi(false)
    }
  }

  const onClickInstall = () => {
    setDisableMintButton(true)
    onboarding.startOnboarding()
  }

  const onClickConnect = async () => {
    try {
      const addressArray = await requestAccounts()
      setWalletAddress(addressArray[0])
      setMetamaskState("connected");
    } catch (error) {
      setMetamaskState("unconnected");
      console.log(error)
    }
  }

  const mintNft = () => {
    mintToken(mintAmount, walletAddress).then(tx => {
      console.log(tx)
      supplyEvent(getTotalSupply)
      setWhitelistMints(Math.max(0, whitelistMints - 1))
    })
  }

  const mintBtnOnClick = () => {
    // if(isMetaMaskInstalled()) {
    //   if(metamaskState === "connected") {
    //     mintNft()
    //   } else {
    //     onClickConnect()
    //   }
    //   setDisableMintButton(false)
    // } else {
    //   onClickInstall()
    //   setDisableMintButton(false)
    // }

  }

  
  const displayLabel = () => {
    if(mintAmount in mintAmountMap){
      return  <TextFieldLabel>{mintAmount}</TextFieldLabel> //+": " + mintAmountMap[mintAmount] + " ETH"
    }
    return
  }

  const increaseMintAmount = () => {
    if(mintAmount < 10 ){
      setMintAmount(mintAmount+1)
    }
  }

  const decreaseMintAmount = () => {
    if(mintAmount > 1 ){
      setMintAmount(mintAmount-1)
    }
  }

  return (
    <>
      <InfoContainer id="mint" >
        <MintSectionBg src={scaryTrees} />
        <InfoWrapper>
          <InfoRow>
              <ImgWrap>
                <Img src={mintImage} />
              </ImgWrap>
            <TextWrapper>
              <TopLine>Completely On Chain!</TopLine>
              <Heading>Sold Out!</Heading>
              { displayMintUi && (
                <MintUiWrapper>            
                    <AmountButton 
                      onClick={decreaseMintAmount}
                      disabled={cantDecreaseMintAmount()}>
                      <FaMinus size={20} />
                    </AmountButton> 
                    {displayLabel()}
                    <AmountButton 
                      onClick={increaseMintAmount}
                      disabled={cantIncreaseMintAmount()}>
                      <FaPlus size={20} />
                    </AmountButton>
                </MintUiWrapper>
              )}
              <BtnWrap>
                <Btn 
                  className="metaMaskButton" 
                  to={{ pathname: "https://opensea.io/collection/bit-monsters-nft" }} target="_blank"> 
                    View on OpenSea
                </Btn>
              </BtnWrap>
            </TextWrapper>
          </InfoRow>
        </InfoWrapper>
      </InfoContainer>
    </>
  )
}

export default MintSection
